import { render, staticRenderFns } from "./TermsSignature.vue?vue&type=template&id=899b31b0&scoped=true&"
import script from "./TermsSignature.vue?vue&type=script&lang=ts&setup=true&"
export * from "./TermsSignature.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./TermsSignature.vue?vue&type=style&index=0&id=899b31b0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899b31b0",
  null
  
)

export default component.exports